// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__1W3el","contained":"OpenButton_contained__2_OBW","disabled":"OpenButton_disabled__3zsxg","error":"OpenButton_error__2_ZVM"};